export default __webpack_public_path__ + "static/media/logo-imdb.92260f7a.svg";